import styled from 'styled-components';
import { Card } from 'antd';

export const StyledCard = styled(Card)`
  margin-bottom: 24px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  }
`;

export const FormSectionTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;

  .icon {
    color: #1890ff;
    font-size: 18px;
  }
`;

export const InstructionBox = styled.div`
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 16px;
  display: flex;
  gap: 12px;
  align-items: flex-start;

  .icon {
    color: #0050b3;
    flex-shrink: 0;
    font-size: 16px;
    margin-top: 2px;
  }

  .text {
    color: #0050b3;
    font-size: 13px;
    line-height: 1.5;
    margin: 0;
  }
`;

export const TableContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

  .ant-table {
    border-radius: 8px 8px 0 0;
  }

  .ant-table-title {
    padding: 16px;
    border-bottom: 1px solid #f0f0f0;
  }
`;

export const SummaryBox = styled.div`
  background: #fafafa;
  border-left: 4px solid #1890ff;
  padding: 10px;
  border-radius: 4px;
  margin-top: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

  .summary-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }

    .label {
      font-size: 14px;
      font-weight: 500;
      color: #595959;
    }

    .value {
      font-size: 16px;
      font-weight: 600;
      color: #262626;
    }
  }

  .total-final {
    font-size: 18px;
    font-weight: 700;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 2px solid #d9d9d9;
    color: #1890ff;
  }
`;

export const InfoAlert = styled.div`
  background-color: #fffbe6;
  border: 1px solid #ffc069;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 16px;
  display: flex;
  gap: 12px;
  align-items: flex-start;

  .icon {
    color: #ad6800;
    flex-shrink: 0;
    font-size: 16px;
    margin-top: 2px;
  }

  .text {
    color: #ad6800;
    font-size: 13px;
    line-height: 1.5;
    margin: 0;
  }
`;

export const EmptyStateBox = styled.div`
  background: #fafafa;
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  color: #8c8c8c;

  .icon {
    font-size: 48px;
    margin-bottom: 12px;
  }

  .text {
    font-size: 14px;
    margin-bottom: 16px;
  }

  button {
    margin-top: 12px;
  }
`;

export const HeaderWrapper = styled.div`
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;
`;

export const SectionWrapper = styled.div`
  margin-bottom: 32px;
`;

export const SalesModeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const SalesModeCard = styled.div`
  border: 1px solid #d9e2f2;
  border-radius: 10px;
  background: linear-gradient(180deg, #ffffff 0%, #fafcff 100%);
  padding: 18px;

  .eyebrow {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 999px;
    background: #eef6ff;
    color: #1358a5;
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  h4 {
    margin: 0 0 8px;
    font-size: 16px;
    color: #1f1f1f;
  }

  p {
    margin: 0;
    color: #595959;
    line-height: 1.55;
  }

  .metaRow {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: center;
    margin: 18px 0 14px;
    padding: 12px 14px;
    border-radius: 8px;
    background: #f5f9ff;
    color: #434343;
  }

  .hint {
    margin-top: 12px;
    color: #8c8c8c;
    font-size: 12px;
    line-height: 1.5;
  }

  .ant-btn {
    min-width: 190px;
  }
`;
